import { render, staticRenderFns } from "./discoverSix.vue?vue&type=template&id=0eb2b6eb&"
import script from "./discoverSix.vue?vue&type=script&lang=js&"
export * from "./discoverSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports